<template>
  <div>
    <data :id="errorTarget"></data>
    <div class="valuation-layout__condition-grid"
      :class="{ 'valuation-layout__condition-grid--extra-button': hasMoreThanFourOptions }"
    >
      <div 
        v-for="option in options"
        :key="option.value"
        :class="{
          'valuation-layout__condition-option': true,
          'valuation-layout__selected-condition': option.value === value
        }"
      >
        <input
          type="radio"
          :name="name"
          :id="name + '-' + option.value"
          :value="option.value"
          v-model="internalValue"
          class="valuation-layout__radio-input"
          autocomplete="off"
          :data-validate="validate"
          :data-validate-message="validateMessage"
          :data-error-target="errorTarget"
        />
        <label class="valuation-layout__radio-label" :for="name + '-' + option.value">
          {{ option.label }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      default: '',
      required: true
    },
    name: {
      type: String,
      required: true
    },
    validate: {
      type: String,
      default: "radio"
    },
    validateMessage: {
      type: String,
      default: "Please make a selection"
    },
    errorTarget: {
      type: String,
      default: "conditionError"
    }
  },
  methods:{
    formatOptionLabel(option) {
      return option.replace(/_/g, ' ').charAt(0).toUpperCase() + option.slice(1).replace(/_/g, ' ');
    }
  },
  computed: {
    hasMoreThanFourOptions() {
      return this.options.length > 4;
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/RadioOptionButtons.vue